import _ from 'lodash';

// Vendored from @vidende/components/utils/React (Client's utils/React). The ticket
// reducer + ticketHelper need this pure helper, but @vidende/store must NOT import
// @vidende/components (that package already imports @vidende/store — importing it
// back would be a circular dependency). Copied here to keep the store self-contained.
export function checkifEdited(
    newState,
    oldState,
    editedKey = 'edited',
    fieldsArray = null,
) {
    if (newState.edited || _.isEqual(newState, oldState)) {
        return checkNewStateEdited(oldState, newState, editedKey, fieldsArray);
    } else {
        return Object.assign({}, newState, {
            [editedKey]: fieldsArray ? [fieldsArray] : true,
        });
    }
}

function checkNewStateEdited(oldState, newState, editedKey, fieldsArray) {
    if (newState.edited === true || !oldState.edited || !fieldsArray) {
        return newState;
    }
    if (!_.includes(oldState.edited, fieldsArray)) {
        return Object.assign({}, newState, {
            [editedKey]: [...oldState.edited, fieldsArray],
        });
    }
    return newState;
}
